import { Controller } from "@hotwired/stimulus"
import { createModalBehavior } from "../utils/modal_behavior"

export default class extends Controller {
  static targets = ["input", "search", "list", "hidden", "modal", "modalBox", "button"]

  connect() {
    this.options = []
    if (this.hasButtonTarget) {
      this.buttonTarget.disabled = !this.hiddenTarget.value
    }

    this.behavior = createModalBehavior({
      getBackdrop: () => (this.hasModalTarget ? this.modalTarget : null),
      getModal: () => this.modalBoxTarget,
    })

    this.disconnectSwipeClose = this.behavior.listenForSwipeClose(() => this.close())
  }

  disconnect() {
    this.disconnectSwipeClose()
  }

  isOpen() {
    return this.behavior.isOpen()
  }

  refreshOptions() {
    this.options = Array.from(this.listTarget.querySelectorAll("li"))
  }

  open() {
    this.behavior.open({
      before: () => {
        // We are clearing previous input values when modal is opened
        this.inputTarget.value = ''
        this.hiddenTarget.value = ''
        if (this.hasButtonTarget) this.buttonTarget.disabled = true
      },
      onDesktopOpen: () => this.searchTarget.focus(),
    })
  }

  close() {
    this.behavior.close({
      onComplete: () => {
        this.searchTarget.value = ""
        this.filter()
      },
    })
  }

  filter() {
    const query = this.searchTarget.value.toLowerCase().trim()

    this.options.forEach((opt) => {
      const text = opt.textContent.toLowerCase()
      opt.classList.toggle("hidden", !text.includes(query))
    })
  }

  choose(event) {
    const li = event.currentTarget
    const value = li.dataset.value
    const displayEl = li.querySelector("[data-text-display]")

    const text = displayEl ?
      displayEl.textContent.trim() :
      li.textContent.trim()

    this.inputTarget.value = text
    this.hiddenTarget.value = value
    if (this.hasButtonTarget) this.buttonTarget.disabled = false

    this.close()
  }
}
